<div class="block--bg-header-color">
    <header
        class="v4-header block--header"
        [ngClass]="{
            'v4-header--multiple-logos': env.SIGN_ON_PAGE,
            'header--mobile-menu-open': mobileMenuOpen === true
        }">
        <div class="v4-header__col-brand">
            <a [routerLink]="(env.SIGN_ON_PAGE ? '/login' : '/home') | localize">
                <img
                    class="v4-header__col-brand-img hide-for-wcag"
                    src="{{ assetsPath$ | async }}/logo.png"
                    attr.alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />
                <img
                    class="v4-header__col-brand-img show-high-contrast-view"
                    src="{{ assetsPath$ | async }}/logo-wcag.png"
                    attr.alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />
            </a>
        </div>

        <div class="v4-header__col-info-links menu-item">
            <div class="shopping-cart" *ngIf="!env.HEADER.HIDE_SHOPPING_CART">
                <gl-header-shopping-cart></gl-header-shopping-cart>
                <gl-header-shopping-cart-countdown-timer-visual></gl-header-shopping-cart-countdown-timer-visual>
            </div>

            <div
                class="v4-header__info"
                *ngIf="!env.HEADER.HIDE_LOGIN_STATUS"
                [ngClass]="{ login: ridangoAuth.getLoginStatus() }">
                <div class="v4-header__info-link login-info" *ngIf="!ridangoAuth.getLoginStatus()">
                    <a class="v4-header__info-link" [routerLink]="'/login' | localize">
                        <span class="v4-header__info-icon icon icon-login"></span>
                        <span class="v4-header__info-link-text user-login">
                            {{ 'HEADER_SECONDARY_NAV_LOGIN' | translate }}
                        </span>
                    </a>

                    <span class="line-separator" *ngIf="!ridangoAuth.getLoginStatus()">|</span>

                    <a class="v4-header__info-link" [routerLink]="'/register' | localize">
                        <span class="v4-header__info-link-text user-register">
                            {{ 'HEADER_SECONDARY_NAV_REGISTER' | translate }}</span
                        >
                    </a>
                </div>

                <div class="v4-header__info-link account-info" *ngIf="ridangoAuth.getLoginStatus()">
                    <span class="v4-header__info-icon icon icon-login"></span>
                    <a
                        class="v4-header__info-link link user-email"
                        [routerLink]="'/account/related-cards' | localize"
                        >{{ loggedInCustomer }}</a
                    >
                    |
                    <a
                        class="v4-header__info-link link user-logout"
                        (click)="logout()"
                        (keydown.enter)="logout()"
                        (keydown.space)="logout()"
                        tabindex="0">
                        {{ 'MAIN_MENU_LOGOUT' | translate }}</a
                    >
                </div>
            </div>

            <div class="v4-header__info languages" *ngIf="!env.HEADER.HIDE_LANGUAGE_SELECTOR">
                <ridango-header-menu-item
                    [languages]="languages"
                    [selected]="selected"
                    (onLanguageSelected)="changeLanguage($event)">
                </ridango-header-menu-item>
            </div>

            <div class="v4-header__info" *ngIf="!env.HEADER.HIDE_MOBILE_MENU">
                <div class="v4-header__info-link-burger">
                    <span
                        class="v4-header__info-icon icon header__mobile-menu-icon"
                        (click)="toggleMobileMenu()"
                        (keydown.enter)="toggleMobileMenu()"
                        (keydown.space)="toggleMobileMenu()"
                        tabindex="0"
                        attr.aria-expanded="{{ mobileMenuOpen }}"
                        role="button"
                        attr.aria-label="{{ 'OPEN_NAVIGATION_ARIA_LABEL' | translate }}"></span>
                </div>
            </div>
        </div>

        <nav *ngIf="!env.HEADER.HIDE_NAV">
            <div class="v4-header__col-menu">
                <ul class="v4-header__menu">
                    <li *ngIf="headerLinks.includes('buy-ticket')">
                        <a
                            class="v4-header__menu-item link link--nav-item-action"
                            #link1="routerLinkActive"
                            [attr.aria-current]="link1.isActive ? 'page' : null"
                            [routerLink]="'/purchase/ticket' | localize"
                            routerLinkActive="active">
                            {{ 'HEADER_PERIOD_TICKETS' | translate }}
                            <div class="underline-item"></div>
                        </a>
                    </li>

                    <li *ngIf="headerLinks.includes('add-money')">
                        <a
                            class="v4-header__menu-item link link--nav-item-action"
                            #link2="routerLinkActive"
                            [attr.aria-current]="link2.isActive ? 'page' : null"
                            [routerLink]="'/purchase/wallet' | localize"
                            routerLinkActive="active">
                            {{ 'HEADER_ADD_MONEY' | translate }}
                            <div class="underline-item"></div>
                        </a>
                    </li>

                    <li *ngIf="headerLinks.includes('personalize')">
                        <a
                            class="v4-header__menu-item link link--nav-item-action"
                            #linkPersonalize="routerLinkActive"
                            [attr.aria-current]="linkPersonalize.isActive ? 'page' : null"
                            [routerLink]="'/personalize' | localize"
                            routerLinkActive="active">
                            {{ 'HEADER_PERSONALIZE' | translate }}
                            <div class="underline-item"></div>
                        </a>
                    </li>

                    <li *ngIf="headerLinks.includes('bike-garage')">
                        <a
                            class="v4-header__menu-item linkA link--nav-item-action"
                            #linkBike="routerLinkActive"
                            [attr.aria-current]="linkBike.isActive ? 'page' : null"
                            [routerLink]="'/purchase/garage' | localize"
                            routerLinkActive="active">
                            {{ 'HEADER_BIKE_GARAGE' | translate }}
                            <div class="underline-item"></div>
                        </a>
                    </li>

                    <li *ngIf="headerLinks.includes('map')">
                        <a
                            class="v4-header__menu-item link link--nav-item-action"
                            #scheduleLink="routerLinkActive"
                            [attr.aria-current]="scheduleLink.isActive ? 'page' : null"
                            [routerLink]="'/schedule' | localize"
                            routerLinkActive="active">
                            {{ 'HEADER_MAP' | translate }}
                            <div class="underline-item"></div>
                        </a>
                    </li>

                    <li *ngIf="env.ONDEMAND?.SHOW_LINKS && headerLinks.includes('book-a-ride') && showBookARide">
                        <a
                            class="v4-header__menu-item link link--nav-item-action"
                            [routerLink]="'/book-a-ride' | localize"
                            routerLinkActive="active">
                            {{ 'HEADER_BOOK_RIDE' | translate }}
                            <div class="underline-item"></div>
                        </a>
                    </li>

                    <li *ngIf="env.ONDEMAND?.SHOW_LINKS && headerLinks.includes('ondemand-trips')">
                        <a
                            class="v4-header__menu-item link link--nav-item-action"
                            [routerLink]="'/ondemand-trips' | localize"
                            routerLinkActive="active">
                            {{ 'HEADER_ONDEMAND_TRIPS' | translate }}
                            <div class="underline-item"></div>
                        </a>
                    </li>

                    <li *ngIf="headerLinks.includes('my-account')">
                        <a
                            class="v4-header__menu-item link link--nav-item-action"
                            #link3="routerLinkActive"
                            [attr.aria-current]="link3.isActive ? 'page' : null"
                            [routerLink]="'/account' | localize"
                            routerLinkActive="active">
                            {{ 'HEADER_MY_ACCOUNT' | translate }}
                            <div class="underline-item"></div>
                        </a>
                    </li>

                    <li *ngIf="headerLinks.includes('bankcard-tickets')">
                        <a
                            class="v4-header__menu-item link link--nav-item-action"
                            [routerLink]="'/bankcard-tickets' | localize"
                            routerLinkActive="active">
                            {{ 'HEADER_BANKCARD_TICKETS' | translate }}
                            <div class="underline-item"></div>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>

        <gl-mobile-menu
            *ngIf="mobileMenuOpen"
            [mobileMenuOpen]="mobileMenuOpen"
            (didToggleMobileMenu)="toggleMobileMenu()"
            (didCloseMobileMenu)="closeMobileMenu()"
            (didLanguageChange)="handleLanguageChange($event)"
            (didLogOut)="logout()">
        </gl-mobile-menu>
    </header>
</div>
